require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-how-does-the-fy-25-house-sfops-bill-and-the-fy-25-presidents.json") })
        }
      }, "path---en-us-update-how-does-the-fy-25-house-sfops-bill-and-the-fy-25-presidents");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-how-does-the-fy-25-house-sfops-bill-and-the-fy-25-presidents!./.cache/json/en-us-update-how-does-the-fy-25-house-sfops-bill-and-the-fy-25-presidents.json
// module id = 732
// module chunks = 231608221292675